export const DADATA_API_KEY = 'f5e85b7c9eff455f9018005d7a829fd6c966ea11';
//export const DADATA_API_KEY = '64d1690c76c8e50a261b2392f90503a8e82c627c';

export const MIXPANEL_API_KEY = 'e7a16a23ec09f0182a9cdf723a89fcde';
export const BRANCHIO_API_KEY = 'key_test_iiZtrBhnJiEVdqqx6Be3aibpzygqRgv8';
